import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from '../../redux/connect';
import {
  getGalleryIsOpen,
  isIssuePreviewModalNavigationDisabled,
} from '../../redux/selectors';
import { trackEvent as trackEventAction } from '../../redux/actions';
import T from 'i18n-react';
import { screenType } from '../../constants/analytics';
import IssuePreview from '../../components/IssuePreview';
import { ModalPreviewNavigation } from '@adsk/bim360-matrix-react-components';
import { issuesSortOrderArrayType } from '../../constants/proptype-validation';
import { viewRfiClose } from '../../utils/analytics-helpers';


export class PureIssuePreviewModal extends PureComponent {

  constructor(props) {
    super(props);

    this.state = this.getInitialState();

    this.onPreviewNext = this.onPreviewNext.bind(this);
    this.onPreviewPrev = this.onPreviewPrev.bind(this);
    this.onModalHide = this.onModalHide.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isModalOpen && this.props.isModalOpen) {
      this.setState({ openModalTime: Date.now() });
    }
  }

  getInitialState() {
    return {
      disableKeyboard: false,
    };
  }

  renderContent() {
    return (
      <IssuePreview
        container={this.props.container}
        origin={screenType.PROJECT}
        disableKeyboard={(disableKeyboard) => this.setState({ disableKeyboard })}
        closeIssuePreview={this.onModalHide}
      />
    );
  }

  onPreviewNext() {
    const { issueId, issuesSortOrder, changePreviewId, onNext } = this.props;
    
    this.setState({ openModalTime: Date.now() });
    
    if (onNext) {
      return onNext();
    }
    const length = issuesSortOrder.length;
    let index = issuesSortOrder.indexOf(issueId);
    index = index === length - 1 ? 0 : index + 1;
    return changePreviewId(issuesSortOrder[index]);
  }
  
  onPreviewPrev() {
    const { issueId, issuesSortOrder, changePreviewId, onPrev } = this.props;
    
    this.setState({ openModalTime: Date.now() });
    
    if (onPrev) {
      return onPrev();
    }
    let index = issuesSortOrder.indexOf(issueId);
    index = index === 0 ? issuesSortOrder.length - 1 : index - 1;
    return changePreviewId(issuesSortOrder[index]);
  }

  onModalHide() {
    const { trackEvent, issueId, issueStatus, onClose } = this.props;
    const { openModalTime } = this.state;
    const timeToCloseModal = Math.round((Date.now() - openModalTime) / 1000);
    
    trackEvent(viewRfiClose(issueId, issueStatus, timeToCloseModal));

    onClose();
    this.setState(this.getInitialState());
  }

  render() {
    const { isNavigationDisabled, issuesSortOrder, changePreviewId, container, isModalOpen, onNext } = this.props;
    const keyboard = !(this.state.disableKeyboard || this.props.attachmentGalleryIsOpen);
    const navigationEnabled = onNext || (!isNavigationDisabled && !!(issuesSortOrder && changePreviewId));
    const modalProps = {
      bsClass: 'IssuePreviewModal',
      show: isModalOpen,
      backdrop: 'static',
      onHide: () => {
        this.onModalHide();
      },
      onExited: () => {
      },
      bsSize: 'large',
      container,
      keyboard,
    };
    return (
      <ModalPreviewNavigation
        bootstrapModal={modalProps}
        id="issuePreviewContainer"
        navigationEnabled={navigationEnabled}
        next={this.onPreviewNext}
        previous={this.onPreviewPrev}
        disabledNavigationArrows={this.props.attachmentGalleryIsOpen}
      >
        {this.renderContent()}
      </ModalPreviewNavigation>
    );
  }
}

PureIssuePreviewModal.NavigationTabIds = {
  DETAILS: 'details',
  ACTIVITY: 'activity',
};

PureIssuePreviewModal.NavigationTabs = [
  {
    id: PureIssuePreviewModal.NavigationTabIds.DETAILS,
    name: () => T.translate('preview.tabs.details'),
  },
  {
    id: PureIssuePreviewModal.NavigationTabIds.ACTIVITY,
    name: () => T.translate('preview.tabs.activity'),
  },
];


PureIssuePreviewModal.displayName = 'IssuePreviewModal';

PureIssuePreviewModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  container: PropTypes.object,
  changePreviewId: PropTypes.func,
  issueId: PropTypes.string,
  issuesSortOrder: issuesSortOrderArrayType,
  onClose: PropTypes.func.isRequired,
  onNext: PropTypes.func,
  onPrev: PropTypes.func,
  attachmentGalleryIsOpen: PropTypes.bool.isRequired,
  isNavigationDisabled: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  attachmentGalleryIsOpen: getGalleryIsOpen(state),
  isNavigationDisabled: isIssuePreviewModalNavigationDisabled(state),
});

const mapDispatchToProps = { trackEvent: trackEventAction };

export default connect(mapStateToProps, mapDispatchToProps)(PureIssuePreviewModal);
